import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateIdentifierAction } from 'Store/customer/action'

type Props = {
  children: React.ReactNode
}

const MainLayout: React.FunctionComponent<Props> = ({ children }) => {
  const [allow, setAllow] = useState<boolean | undefined>(undefined)
  const dispatch = useDispatch()

  useEffect(() => {
    try {
      const userInfo = localStorage.getItem('me') || ''
      const profile = JSON.parse(userInfo)
      if (profile && profile.me && profile.me.identifier) {
        dispatch(updateIdentifierAction(profile.me.identifier))
        setAllow(true)
      }
    } catch (e) {
      console.log(e)
      setAllow(false)
    }
  }, [])

  if (allow === undefined) {
    return <>Loading</>
  }

  return <>{children}</>
}

export default MainLayout
